import geoLocation from './location';

export default {
  geoLocation,
};
